import { render, staticRenderFns } from "./TheHeaderDropdown.vue?vue&type=template&id=cb87152c&scoped=true&"
import script from "./TheHeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdown.vue?vue&type=style&index=0&id=cb87152c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb87152c",
  null
  
)

export default component.exports